import React, { createContext, useContext } from 'react';

// Mirrors backend/utils/permissions.js + middleware/rbac.js exactly: the
// legacy role='admin' superuser always passes, everyone else is checked
// against the permission map the server resolved at login/verify time.
export function can(user, moduleKey, action = 'view') {
  if (!user) return false;
  if (user.role === 'admin' || user.isSuperAdmin) return true;
  const col = { view: 'can_view', create: 'can_create', edit: 'can_edit', delete: 'can_delete' }[action];
  return !!user.permissions?.[moduleKey]?.[col];
}

const PermissionsContext = createContext(null);

export function PermissionsProvider({ user, children }) {
  return <PermissionsContext.Provider value={user}>{children}</PermissionsContext.Provider>;
}

// usePermissions().can('students', 'create')
export function usePermissions() {
  const user = useContext(PermissionsContext);
  return {
    user,
    can: (moduleKey, action = 'view') => can(user, moduleKey, action),
  };
}

// <Can module="students" action="create"><button>Add</button></Can>
// Renders nothing when the current admin user lacks the permission. Not
// used on the hostel portal side (hostel actors aren't RBAC-governed).
export function Can({ module, action = 'view', children }) {
  const { can: check } = usePermissions();
  return check(module, action) ? children : null;
}
